import { useTranslation } from 'react-i18next';
import { Button, Icon, Space } from 'Components';
import { getAppRoutes } from 'Pages/App/App.constants';
import { useHistory } from 'react-router-dom';
import ModalContextProvider, { useModal } from 'Hooks/useModal';
import RolesActionsModals, {
	RolesActionsModalsProps
} from './RolesActionsModals';
import { PermissionCode } from 'Services/Api/Users/Types';
import { usePermission } from 'Components/Permission/Permission.hooks';
import RolesExportButton, {
	RolesExportButtonProps
} from './components/RolesExportButton';
import "./styles/Roles.module.scss";
import { SystemRole } from 'Services/Api/Roles/Types';

type RolesActionsContentProps = RolesActionsModalsProps &
	RolesExportButtonProps & {
		selectedTenantValue: number;
		hasData: boolean,
		dataSource: SystemRole[];
	};
function RolesActionsContent(props: RolesActionsContentProps) {
	const permission = usePermission();
	const history = useHistory();
	const { t } = useTranslation();

	const onAdd = () => {
		history.push(getAppRoutes().ADD_ROLE);
	};

	const {
		permittedByCode: {
			[PermissionCode.CREATE_SECONDARY_ROLE]: isAddPermitted,
			[PermissionCode.ExportSystemRoles]: isExportPermitted
		}
	} = permission.getHasPermission({
		code: [
			PermissionCode.CREATE_SECONDARY_ROLE,
			PermissionCode.ExportSystemRoles
		]
	});

	return (
		<>
			<RolesActionsModals {...props} />
			<Space>
				{isExportPermitted && (
					<RolesExportButton
						dataSource={props.dataSource}
						disabled={!props.hasData}
					/>
				)}

				{isAddPermitted && !!props.selectedTenantValue && (
					<Button
						type="primary"
						shape="round"
						className="add-role-button"
						icon={<Icon type="plus" />}
						onClick={onAdd}
					>
						{t('roles.add')}
					</Button>
				)}
			</Space>
		</>
	);
}

const RolesActions = (props: RolesActionsContentProps) => (
	<ModalContextProvider>
		<RolesActionsContent {...props} />
	</ModalContextProvider>
);

export default RolesActions;
